export const FETCH_DATE_RANGE = 'FETCH_DATE_RANGE'
export const CHANGE_DATE_RANGE = 'CHANGE_DATE_RANGE'
export const FETCH_CHART = 'FETCH_CHART'
export const FETCH_CHART_ERROR = 'FETCH_CHART_ERROR'
export const FETCH_CHART_PENDING = 'FETCH_CHART_PENDING'
export const FETCH_CHART_FULFILLED = 'FETCH_CHART_FULFILLED'
export const TIME_STEP_CHANGE = 'TIME_STEP_CHANGE'
export const DATE_RANGE_FROM_STATE = 'DATE_RANGE_FROM_STATE'
export const SET_CUSTOM_DATE = 'SET_CUSTOM_DATE'
export const APPLY_CUSTOM_DATE_RANGE = 'APPLY_CUSTOM_DATE_RANGE'
export const RESET_CUSTOM_DATE_RANGE = 'RESET_CUSTOM_DATE_RANGE'
export const SET_PAGE_KEY = 'SET_PAGE_KEY'
export const ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const TOGGLE_SHORT_TERM_CACHE = 'TOGGLE_SHORT_TERM_CACHE'
export const TOGGLE_INCLUDE_TESTERS = 'TOGGLE_INCLUDE_TESTERS'
export const BRAND_SELECTION = 'BRAND_SELECTION'
export const GET_LATEST_LOGOS = 'GET_LATEST_LOGOS'
export const GET_LATEST_LOGOS_PENDING = 'GET_LATEST_LOGOS_PENDING'
export const GET_LATEST_LOGOS_FULFILLED = 'GET_LATEST_LOGOS_FULFILLED'
export const GET_LATEST_LOGOS_ERROR = 'GET_LATEST_LOGOS_ERROR'
export const SET_TABLE_FILTER = 'SET_TABLE_FILTER'
export const SET_TABLE_PAGE = 'SET_TABLE_PAGE'
